import PageHeader from "@/components/PageHeader";
import Membership from "@/sections/Membership";
import Trust from "@/sections/Trust";

export default function MembershipPage() {
  return (
    <>
      <PageHeader
        testid="membership-header"
        eyebrow="Üyelik"
        titleLines={["Daha seçici bir", "dating deneyimi."]}
        lede="Five Star üyelik tabanlı bir deneyimdir. Abonelikler App Store üzerinden yönetilir; üyeliğini istediğin zaman görüntüleyebilir veya iptal edebilirsin."
      />
      <Membership showLink={false} />
      <Trust />
    </>
  );
}
